import { render } from "./Laboratorio.vue?vue&type=template&id=233210f6&scoped=true"
import script from "./Laboratorio.vue?vue&type=script&lang=js"
export * from "./Laboratorio.vue?vue&type=script&lang=js"

import "./Laboratorio.vue?vue&type=style&index=0&id=233210f6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233210f6"]])

export default __exports__